import domReady from '@wordpress/dom-ready';

domReady(() => {
  const mobileBreakpoint = 1024;
  const linksCollection = document.querySelectorAll(
    '.vcc--sidebar .navigation-wrapper'
  );

  function wrapLinks() {
    linksCollection.forEach((links) => {
      if (window.innerWidth <= mobileBreakpoint) {
        links.classList.add('collapse');
      } else {
        links.classList.remove('collapse');
      }
    });
  }

  wrapLinks();
  window.addEventListener('resize', wrapLinks);
});
